export default __webpack_public_path__ + "static/media/rh.15aaaa3a.png";